import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { amendDcr, amendDer, billingQueryKeys } from '../api/billing.api';
import type { AmendDcrPayload, AmendDerPayload } from '../types/billing.types';

const FAILURE = 'Could not change this claim';

export function useAmendDcr() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ recordId, payload }: { recordId: number; payload: AmendDcrPayload }) =>
      amendDcr(recordId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: billingQueryKeys.all() });
      toast.success('Claim corrected');
    },
    onError: (error) => showApiErrorToast(error, FAILURE),
  });
}

export function useAmendDer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ detailId, payload }: { detailId: number; payload: AmendDerPayload }) =>
      amendDer(detailId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: billingQueryKeys.all() });
      toast.success('Claim corrected');
    },
    onError: (error) => showApiErrorToast(error, FAILURE),
  });
}
